import React, { ComponentType } from 'react'

import { Html } from '@application/Interfaces/Atoms/Html'
import { Image } from '@application/Interfaces/Atoms/Image'
import { LinkedInIcon } from '@application/Interfaces/Icons'
import { ImageDescriptionSlideoutItemType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'

import {
    BioWrapper,
    Description,
    ImageWrapper,
    LinkedInWrapper,
    Name,
    Post,
    SlideOut,
    TopWrapper,
} from './ImageDescriptionSlideoutDetails.styled'

type MemberDetailsProps = Omit<ImageDescriptionSlideoutItemType, 'otherLink'> & {
    isOpen: boolean
    onClose: () => void
    Footer: ComponentType
}

export const ImageDescriptionSlideoutDetails = ({
    isOpen,
    onClose,
    image,
    linkedinProfile,
    title,
    subtitle,
    description,
    Footer,
}: MemberDetailsProps): JSX.Element => {
    return (
        <SlideOut
            isOpen={isOpen}
            onClose={onClose}
            withHeader={false}
            Footer={Footer}
            classes={{ header: 'member-header', body: 'member-body', footer: 'member-footer' }}
        >
            <TopWrapper>
                <Grid container alignItems="end">
                    <Grid item xs={10} sm={8} md={10}>
                        <ImageWrapper>{image && <Image image={image} />}</ImageWrapper>
                    </Grid>
                    <Grid item xs={2} sm={4} md={2} container justifyContent="end">
                        {linkedinProfile && (
                            <LinkedInWrapper href={linkedinProfile} target="_blank">
                                <LinkedInIcon colorCode="white" width={36} height={36} />
                            </LinkedInWrapper>
                        )}
                    </Grid>
                </Grid>
            </TopWrapper>
            <BioWrapper>
                <Name>{title}</Name>
                {subtitle && <Post>{subtitle}</Post>}
                {description?.data && (
                    <Description>
                        <Html content={description.data.childMarkdownRemark.html} />
                    </Description>
                )}
            </BioWrapper>
        </SlideOut>
    )
}
